export const SimulationState = {
  IDLE: 'IDLE',
  LOADING_SCHOOLS: 'LOADING_SCHOOLS',
  VALIDATING_SCHOOL: 'VALIDATING_SCHOOL',
  CONFIGURING: 'CONFIGURING',
  PREPARING_SESSIONS: 'PREPARING_SESSIONS',
  CONNECTING_DEVICES: 'CONNECTING_DEVICES',
  READY: 'READY',
  RUNNING: 'RUNNING',
  PAUSED: 'PAUSED',
  MANUAL_CONTROL: 'MANUAL_CONTROL',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED',
  STOPPED: 'STOPPED',
} as const;

export type SimulationState = typeof SimulationState[keyof typeof SimulationState];

export type SimulationMode = 'MANUAL' | 'AUTOMATIC';

export interface DemoSchool {
  id: string;
  nome: string;
  codigo: string;
  tipoRede: string;
  cidade: string;
  uf: string;
  email: string | null;
  nomeDiretor: string | null;
  latitude: number | null;
  longitude: number | null;
  totalAlunos: number;
  totalTurmas: number;
  totalProfessores: number;
  totalResponsaveis: number;
  totalGestores: number;
  statusComercial: string;
  perfisDisponiveis: string[];
  dataIntegrityStatus: 'VALID' | 'INVALID' | 'UNCHECKED';
}

export interface IntegrityChecklist {
  isValid: boolean;
  hasDirector: boolean;
  hasSecretaria: boolean;
  hasTeachers: boolean;
  hasStudents: boolean;
  hasParents: boolean;
  teacherTurmaRelation: boolean;
  parentStudentRelation: boolean;
  errors: string[];
}

export interface SimulationActor {
  id: string;
  nome: string;
  email: string;
  perfil: string;
  cargo?: string | null;
  fotoUrl?: string | null;
  genero?: string | null;
  escolaId?: string | null;
}

export interface SimulationStep {
  actorId: string;
  action: string;
  screen: string;
  inputData?: any;
  expectedResult: string;
  syncEvent?: string;
  timeoutMs?: number;
}

export interface SimulationScenario {
  id: string;
  name: string;
  description: string;
  actors: {
    actorId: string;
    perfil: string;
    cargo?: string | null;
  }[];
  steps: SimulationStep[];
}
